import React from 'react'
import {Helmet} from "react-helmet";
import styled from 'styled-components';

// import AnalyticsService from './../../services/AnalyticsService';

import Layout from './../layout/Layout';
import Meta from './../layout/Meta';


const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  text-align: center;
  margin: 30px 0px 60px;
`;
const Code = styled.div.withConfig({displayName:'-Code'})`
  font-size: 150px;
  font-weight: 700;
  color: #AAAAAA;
`;

const Error = styled.div.withConfig({displayName:'-Error'})`
  font-size: 30px;
  font-weight: 700;
  color: #0D609D;

`;

const NotFoundPage = ({layout}) => {

  // useEffect(() => {
  //   AnalyticsService.init();  
  // }, []);

  return ( 
    <>
      <Meta
        title={"404"}
        description={"TODO"}
        image={"https://www.martinapassanante.it/photos/header.jpg"}
      />
      <Helmet>
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <Layout layout={layout}>
        <Wrapper>
          <Code>404</Code>
          <Error>Not Found</Error>
        </Wrapper>        
      </Layout>
    </>
  )
}

export default NotFoundPage
